var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicPrimaryProducers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.779.033C6.205-.307-.554 1.957.036 7.495l.002.017c.067.617.861.86 1.256.377 1.499-1.834 3.423-2.726 4.371-3.077-1.738 1.132-4.458 3.582-4.88 7.997A1.09 1.09 0 0 0 1.872 14h.017c.594 0 1.078-.464 1.092-1.049a13.76 13.76 0 0 1 .224-2.153c2.601.496 5.974-1.065 6.799-4.999.67-3.2 1.669-4.782 2.863-5.334.218-.1.15-.42-.089-.432",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicPrimaryProducers);
export default __webpack_public_path__ + "static/media/trophic-primary-producers.aef14eae22993774c778c84cdf94d16c.svg";
export { ForwardRef as ReactComponent };